module.exports = __webpack_public_path__ + "img/qualityIndexScore1.c6d21e1b.png";